module.exports = __webpack_public_path__ + "static/media/no_sound.3db0eb34.mp3";